const LOGIN_PATH = '/login';

export const resolveReturnPath = (search: string): string => {
  const raw = new URLSearchParams(search).get('returnUrl')?.trim();
  if (!raw || !raw.startsWith('/')) {
    return '/';
  }

  return raw;
};

export const shouldIncludeReturnUrl = (returnPath: string): boolean => {
  if (!returnPath || returnPath === '/') {
    return false;
  }

  if (returnPath === LOGIN_PATH || returnPath.startsWith(`${LOGIN_PATH}?`)) {
    return false;
  }

  return true;
};

export const buildLoginPath = (pathname: string, search = '', hash = ''): string => {
  const returnPath = `${pathname}${search}${hash}`;
  if (!shouldIncludeReturnUrl(returnPath)) {
    return LOGIN_PATH;
  }

  return `${LOGIN_PATH}?returnUrl=${encodeURIComponent(returnPath)}`;
};

export const stripEmptyReturnUrlSearch = (search: string): string | null => {
  const params = new URLSearchParams(search);
  if (!params.has('returnUrl')) {
    return null;
  }

  const raw = params.get('returnUrl');
  if (raw?.trim()) {
    return null;
  }

  params.delete('returnUrl');
  const next = params.toString();
  return next ? `?${next}` : '';
};
